import React from 'react';
import { AutoSuggestOption } from '../utils/types';

interface AutoSuggestOptionsProps {
  options: AutoSuggestOption[];
  handleSuggestionClick: (option: AutoSuggestOption) => void;
}

export const AutoSuggestOptions: React.FC<AutoSuggestOptionsProps> = ({
  options,
  handleSuggestionClick
}) => (
  <ul className="autoSuggestOptions">
    {options.map(option => (
      <li
        key={option.term}
        onClick={() => handleSuggestionClick(option)}
        onKeyDown={e => {
          if (e.key === 'Enter' || e.key === ' ') {
            handleSuggestionClick(option);
          }
        }}
        role="button"
        tabIndex={0}
        style={{ marginBottom: '0.2rem' }}
      >
        {option.term}
      </li>
    ))}
  </ul>
);
